import React, { useState, useEffect, useRef } from 'react';
import './About.css';

const About = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [isFounderVisible, setIsFounderVisible] = useState(false);
  const aboutRef = useRef(null);
  const founderRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.1 }
    );

    const founderObserver = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsFounderVisible(true);
        }
      },
      { threshold: 0.1 }
    );

    if (aboutRef.current) {
      observer.observe(aboutRef.current);
    }

    if (founderRef.current) {
      founderObserver.observe(founderRef.current);
    }

    return () => {
      if (aboutRef.current) {
        observer.unobserve(aboutRef.current);
      }
      if (founderRef.current) {
        founderObserver.unobserve(founderRef.current);
      }
    };
  }, []);

  return (
    <section id="about" className="about section">
      <div className="container">
        <div className="about-content" ref={aboutRef}>
          <div className={`about-text ${isVisible ? 'animate-slide-left' : ''}`}>
            <h2 className="section-title">Bridging Generations, Enhancing Lives</h2>
            <p className="section-subtitle">
              E-Q.O.L. is a student-led organization dedicated to improving the quality of life for older adults through innovation and advocacy. We strive to create a world where every generation feels valued, included, and connected, while providing a space for individuals to apply themselves and be part of <strong>change</strong>.
            </p>
            <p className="section-subtitle">
              Because when generations <strong>connect</strong>, something incredible happens: barriers break, stories are shared, and lives are <strong>changed</strong> — on both sides.
            </p>
          </div>
          
          <div className={`about-image ${isVisible ? 'animate-slide-right' : ''}`}>
            <img 
              src="https://images.unsplash.com/photo-1559027615-cd4628902d4a?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80" 
              alt="Intergenerational connection and community" 
              className="about-hero-image"
            />
            <div className="image-overlay">
              <div className="image-content">
                <h3>Our Mission</h3>
                <p>To bridge generations, create real connections, and challenge the way we think about aging through student-led innovation and advocacy.</p>
              </div>
            </div>
          </div>
        </div>
        
        <div className={`founder-message ${isFounderVisible ? 'animate-fade-in' : ''}`} ref={founderRef}>
          <h3>A Word from Our Founder</h3>
          <div className="founder-quote">
            <div className="quote-marks">"</div>
            <p>
              E-Q.O.L. started with a simple idea: <strong>No one should feel forgotten because of age.</strong> While volunteering at a senior home, I noticed that every week felt the same — it felt repetitive, like a routine rather than real engagement. I wanted to change that. What began as a simple desire to bring more variety and joy into their lives quickly turned into a mission to bridge generations, create real connections, and challenge the way we think about aging. This club is more than an organization; it's a movement led by students who believe in the power of inclusivity, innovation, and human connection. Whether you're here to volunteer, design, research, or support, every effort contributes to something bigger. Together, we're building a future where <strong>no one is left behind.</strong>
            </p>
            <div className="quote-marks">"</div>
          </div>
          <div className="founder-signature">
            <img src="/images/ish.png" alt="Ishaan Gupta" className="founder-signature-image" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
